import { render, staticRenderFns } from "./EmployeesGroupSelectModalWorkTypeExtra.vue?vue&type=template&id=eddb9ac6&scoped=true&"
import script from "./EmployeesGroupSelectModalWorkTypeExtra.vue?vue&type=script&lang=js&"
export * from "./EmployeesGroupSelectModalWorkTypeExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb9ac6",
  null
  
)

export default component.exports